module.exports = __webpack_public_path__ + "media/icon/icon-walk-0f6e2cdb.svg";